import { createSelector } from 'reselect';
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';
import reduce from 'ramda/es/reduce';
import prop from 'ramda/es/prop';


const selectAvailableUuids = createSelector(
  [
    state => state.students.data,
  ],
  pipe(
    values,
    reduce((acc, student) => {
      const shopUuid = prop('shopUuid', student);
      acc[shopUuid] = true; // eslint-disable-line no-multi-assign
      return acc;
    }, {})
  )
);

export default selectAvailableUuids;
